'use client'

import { Button } from "@/components/ui/button";
import { ArrowDown, Check } from 'lucide-react';
import { useTranslations } from "next-intl";
import Link from "next/link";
import SectionPageLayout from "../layouts/section-page-layout";
import AnimatedLogo from './animated-logo';
const Hero = () => {
      const t = useTranslations('landing.hero');
      const scrollToFeatures = () => {
            const featuresSection = document.getElementById('features');
            featuresSection?.scrollIntoView({ behavior: 'smooth' });
      };

      return (
            <SectionPageLayout className="pt-24 md:pt-32 pb-16 md:pb-24">
                  <div className="section-container">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                              <div className="order-2 lg:order-1 animate-fade-in">
                                    <div className="inline-block px-3 py-1 mb-6 rounded-full bg-kiwilog/20 text-kiwilog text-sm font-medium">
                                          {t('simplify_product_updates')}
                                    </div>
                                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 mb-6 text-balance dark:text-white">
                                          {t('title')}&nbsp;
                                          <span className="text-4xl md:text-5xl lg:text-6xl font-bold  text-kiwilog">{t('title_highlight')}</span>
                                    </h1>
                                    <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl text-balance dark:text-gray-400">
                                          {t('description')}
                                    </p>

                                    <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                                          <Link href="/signin">
                                                <Button variant="kiwilog" size="lg" className="transition-all button-effect text-md">
                                                      {t('get_started')}
                                                </Button>
                                          </Link>
                                          <Link href="/news">
                                                <Button size="lg" variant="outline" className="transition-all button-effect text-md">
                                                      {t('view_demo')}
                                                </Button>
                                          </Link>
                                    </div>

                                    <div className="mt-8 md:mt-16 flex flex-col items-center sm:items-start sm:flex-row gap-6 text-sm text-gray-500">
                                          <div className="flex items-center">
                                                <Check className="h-5 w-5 text-kiwilog mr-2" />
                                                {t('no_credit_card_required')}
                                          </div>
                                          <div className="flex items-center">
                                                <Check className="h-5 w-5 text-kiwilog mr-2" />
                                                {t('easy_setup_in_minutes')}
                                          </div>
                                          <div className="flex items-center">
                                                <Check className="h-5 w-5 text-kiwilog mr-2" />
                                                {t('cancel_anytime')}
                                          </div>
                                    </div>
                              </div>

                              <div className="order-1 lg:order-2 animate-fade-in">
                                    <AnimatedLogo />
                              </div>
                        </div>

                        <div className="mt-16 flex justify-center">
                              <button
                                    onClick={scrollToFeatures}
                                    className="flex flex-col items-center text-gray-500 hover:text-primary-500 transition-colors focus:outline-none"
                              >
                                    <span className="text-sm font-medium mb-2">{t('discover_features')}</span>
                                    <ArrowDown className="animate-bounce-subtle" />
                              </button>
                        </div>
                  </div>
            </SectionPageLayout>
      );
};

export default Hero;